import React from 'react'
import { useDispatch } from 'react-redux'

import { sendMessages } from 'ducks/concurrency'
import { useModal, useSnackbar } from 'hooks'

const useSendTestsInvitationsMutations = () => {
  const dispatch = useDispatch()

  const handleSendInvitations = React.useCallback(
    (
      { candidates, projectId },
      { onShowSnackbar, onSuccess, postSuccessAction },
    ) => {
      dispatch(
        sendMessages(
          { candidates, projectId },
          { onShowSnackbar, onSuccess, postSuccessAction },
        ),
      )
    },
    [dispatch],
  )

  return {
    handleSendInvitations,
  }
}

export const useSendTestsInvitationsModal = (state, handlers) => {
  const { projectId } = state
  const { handleSetCandidate } = handlers

  const handleReset = React.useCallback(() => {
    handleSetCandidate(null)
  }, [handleSetCandidate])

  const { handleClose, handleOpen, isOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleSendInvitations } = useSendTestsInvitationsMutations()

  const handleSendTestsInvitationsModalClose = React.useCallback(() => {
    handleClose()
    handleReset()
  }, [handleClose, handleReset])

  const handleSendTestsInvitationsModalConfirm = React.useCallback(
    ({ candidates }, { onSuccess }) => {
      handleSendInvitations(
        { candidates, projectId },
        {
          onShowSnackbar: handleShowSnackbar,
          onSuccess: () => {
            onSuccess()
            handleReset()
          },
        },
      )
      handleClose()
    },
    [
      projectId,
      handleClose,
      handleReset,
      handleSendInvitations,
      handleShowSnackbar,
    ],
  )

  return {
    handleSendTestsInvitationsModalClose,
    handleSendTestsInvitationsModalConfirm,
    handleSendTestsInvitationsModalOpen: handleOpen,
    isSendTestsInvitationsModalOpen: isOpen,
  }
}
